import React from 'react'
import { motion } from 'framer-motion'
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa'

import './Footer.scss'

const Footer = () => {
  const socmeds = [
    {
      icon: <FaGithub />,
      link: 'https://github.com/klaseeee'
    },
    {
      icon: <FaLinkedin />,
      link: 'https://www.linkedin.com/in/muklasnurardiansyah'
    },
    {
      icon: <FaInstagram />,
      link: 'https://www.instagram.com/iam_muklas'
    },

  
]

  return (
    <footer>
      <div className="footer__container app__flex">
        <div className="footer__title" style={{ textAlign: 'center' }}>
          <h1>Muklas Nur Ardiansyah</h1>
        </div>
        <div className="footer__socmed">
          {socmeds.map((socmed) => {
            return (
              <motion.div
                className="footer__socmed-item app__flex"
                whileInView={{ opacity: [0, 1] }}
                key={socmed.link}
              >
                <a href={socmed.link} target="_blank" rel="noreferrer" className='app__flex'>{socmed.icon}</a>
              </motion.div>
            )
          })}
        </div>
        <div className="footer__copyright">
          <h4 className="p-text">&copy; Muklas Nur Ardiansyah. All Rights Reserved {new Date().getFullYear()}</h4>
        </div>
      </div>
    </footer>
  )
}

export default Footer